var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollectionKits(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4145 0.0351562C1.44289 0.0351562 0.636719 0.841323 0.636719 1.81293V14.2574C0.636719 15.229 1.44289 16.0352 2.4145 16.0352H14.8589C15.8306 16.0352 16.6367 15.229 16.6367 14.2574V1.81293C16.6367 0.841323 15.8306 0.0351562 14.8589 0.0351562H2.4145ZM2.4145 1.81293H6.85894V5.36849H10.4145V1.81293H14.8589V14.2574H2.4145V1.81293Z",
    fill: "#605DAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectionKits);
export default __webpack_public_path__ + "static/media/collectionKits.e8373ad827f2c619923b9b3993a2bc5b.svg";
export { ForwardRef as ReactComponent };